<template>
  <div class="flex flex-wrap gap-4">
    <span
      v-for="(file, index) in modelValue"
      :key="`${index}_${file?.name}`"
      class="relative flex h-20 w-20 items-center justify-center rounded border"
    >
      <span class="absolute -right-3 -top-3">
        <div
          class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-dark-gray"
          @click="onRemoveFile(index)"
        >
          <img
            class="relative z-10"
            src="@/assets/close-icon-white.svg"
          />
        </div>
      </span>
      <iframe
        v-if="fileNeedsIframe(file)"
        class="h-20 w-20"
        :src="file.preview + '#toolbar=0&navpanes=0&zoom=0'"
        scrolling="no"
        style="overflow: hidden"
      />
      <img
        v-else
        class="h-20 w-20"
        :src="file?.preview"
        style="overflow: hidden"
      />
    </span>
    <span
      class="relative z-10 flex h-20 w-20 cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-yellow-300"
      @click="onClickSelect"
      @drop.prevent="dropFile"
      @dragover.prevent
      @dragenter.prevent="fileOverDropArea = true"
      @dragleave.prevent="fileOverDropArea = false"
    >
      <div
        class="absolute bottom-0 left-0 right-0 top-0 z-0 rounded-lg bg-yellow-500 opacity-10"
      />
      <img
        class="relative z-10"
        src="@/assets/plus-yellow-icon.svg"
      />
      <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg> -->
    </span>
    <input
      id="file-upload"
      ref="fileInput"
      type="file"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      @change="onFileSelect"
    />
  </div>
</template>

<script>
export default {
  name: 'FileSelectorGrid',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    accept: String,
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
  },
  emits: ['update:modelValue'],
  methods: {
    fileNeedsIframe: function (file) {
      const iframeTypes = ['application/pdf'];
      return iframeTypes.includes(file.type);
    },
    onRemoveFile: function (index) {
      const newFiles = [...this.modelValue];
      URL.revokeObjectURL(newFiles[index].preview);
      newFiles.splice(index, 1);
      this.$emit('update:modelValue', [...newFiles]);
    },
    onClickSelect: function () {
      this.$refs.fileInput.click();
    },
    async dropFile(event) {
      const files = event.dataTransfer.files;
      if (!files) {
        return;
      }
      this.refreshFiles(files);
    },
    refreshFiles: function (files) {
      for (const file of files) {
        file.preview = URL.createObjectURL(file);
      }
      console.log(files);
      this.$emit('update:modelValue', [...files]);
    },
    onFileSelect: function (event) {
      const files = event.target.files;
      if (!files) {
        return;
      }
      this.refreshFiles([...files, ...this.modelValue]);
    },
  },
};
</script>

<style>
input[type='file'] {
  display: none;
}

iframe {
  overflow: hidden;
}
</style>
